import { render, staticRenderFns } from "./MemberSearchResults.vue?vue&type=template&id=080f2b92&scoped=true"
import script from "./MemberSearchResults.vue?vue&type=script&lang=js"
export * from "./MemberSearchResults.vue?vue&type=script&lang=js"
import style0 from "./MemberSearchResults.vue?vue&type=style&index=0&id=080f2b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f2b92",
  null
  
)

export default component.exports